import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import {
  styled,
  Box,
  Tooltip,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Dialog,
} from '@mui/material';

import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import ReactHtmlParser from 'react-html-parser';

import {
  Button,
  Typography,
  KeyIcon,
} from '@datanomik/commons-ui';

import CloseIcon from '@mui/icons-material/Close';

import { DatanomikLogoFullBlue } from '../../common/Logo';

import styles from './styles';

const TermsAndConditionsRaw = ({
  className, openLegal, onAccept, legalContent, onClose,
}) => (
  <Dialog
    open={openLegal}
    onClose={onClose}
    fullScreen
    scroll="paper"
    className={className}
  >
    <DialogTitle className="dn-flex-middle dn-flex-between">
      <DatanomikLogoFullBlue />
      <Tooltip title={t('Close')}>
        <IconButton
          className="dn-close-modal"
          aria-label="close"
          size="small"
          onClick={onClose}
          sx={{
            color: '#525866',
          }}
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>
    </DialogTitle>
    <Box>
      <Box className="dn-flex-center">
        <KeyIcon size="xlarge" color="neutral">
          <DescriptionOutlinedIcon />
        </KeyIcon>
      </Box>
      <Typography variant="h5" align="center" mt="4px">{t('Terms and Conditions')}</Typography>
      <Typography variant="p3" color="text.500" mt="4px" align="center">
        {t('Please review and accept to continue using our services.')}
      </Typography>
    </Box>
    <DialogContent>
      <DialogContentText color="text.500">
        {ReactHtmlParser(legalContent)}
        <Box className="dn-flex-center dn-buttons">
          <Button onClick={onClose} variant="outlined">{t('Decline')}</Button>
          <Button onClick={onAccept} variant="contained">
            {t('Accept')}
          </Button>
        </Box>
      </DialogContentText>
    </DialogContent>
  </Dialog>
);

TermsAndConditionsRaw.propTypes = {
  className: PropTypes.string,
  legalContent: PropTypes.string,
  onAccept: PropTypes.func,
  onClose: PropTypes.func,
  openLegal: PropTypes.bool,
};

export const TermsAndConditions = styled(TermsAndConditionsRaw)(styles);

TermsAndConditions.propTypes = TermsAndConditionsRaw.propTypes;
